import { render } from "./MeusDados.vue?vue&type=template&id=2035b447&ts=true"
import script from "./MeusDados.vue?vue&type=script&lang=ts&setup=true"
export * from "./MeusDados.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/meusdados/MeusDados.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2035b447"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2035b447', __exports__)) {
    api.reload('2035b447', __exports__)
  }
  
  module.hot.accept("./MeusDados.vue?vue&type=template&id=2035b447&ts=true", () => {
    api.rerender('2035b447', render)
  })

}


export default __exports__